import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ExhApiError, ExhUser } from "lib/extrahorizon/types";

export interface ExhState {
  isConnected: boolean;
  exhUser: ExhUser | null;
  loading: boolean;
  error: ExhApiError | null;
}

const initialState: ExhState = {
  isConnected: false,
  exhUser: null,
  loading: true, // Start with loading true to prevent premature redirects during auth initialization
  error: null,
};

export const exhSlice = createSlice({
  name: "exh",
  initialState,
  reducers: {
    /**
     * Set ExtraHorizon connection status
     */
    setExhConnected: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload;
    },

    /**
     * Set current ExtraHorizon user
     */
    setExhUser: (state, action: PayloadAction<ExhUser | null>) => {
      state.exhUser = action.payload;
    },

    /**
     * Set loading state for async operations
     */
    setExhLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    /**
     * Set error from SDK operations
     */
    setExhError: (state, action: PayloadAction<ExhApiError | null>) => {
      state.error = action.payload;
    },

    /**
     * Clear error state
     */
    clearExhError: (state) => {
      state.error = null;
    },

    /**
     * Reset all ExtraHorizon state (useful for logout)
     */
    resetExhState: (state) => {
      state.isConnected = false;
      state.exhUser = null;
      state.loading = false;
      state.error = null;
    },
  },
});

// Export actions
export const { setExhConnected, setExhUser, setExhLoading, setExhError, clearExhError, resetExhState } =
  exhSlice.actions;

// Export reducer
export default exhSlice.reducer;
